import { FC } from 'react'

type Props = {
  tagId: string
  onClick: () => void
}

export const ClearSelectButton: FC<Props> = (props: Props) => {
  const { tagId, onClick } = props
  return (
    <button
      id={tagId}
      type="button"
      onClick={onClick}
      className="p-1 pr-2 m-2 inline-flex justify-center items-center rounded-md border border-transparent font-light transition-all text-xs"
      style={{ backgroundColor: '#F7DDDF' }}
      // 背景なし
      // className="hover:underline pt-2 px-0 m-2 inline-flex justify-center items-center rounded-md border border-transparent font-light transition-all text-xs dark:focus:ring-offset-gray-800"
    >
      <svg
        className="h-4 w-4"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        viewBox="0 0 16 16"
      >
        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
      </svg>
      {/* 選択をクリア */}
      <label className="cursor-pointer" htmlFor={tagId}>
        領域選択をクリア
      </label>
    </button>
  )
}
